import type { paths } from "@/api-schema";
import { encodeLogoRequest } from "@/common/helpers/encode-file";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const COMPANY_CREATE_RESOURCE = "company" as const;
export const COMPANY_CREATE_API_PATH = `/v1/${COMPANY_CREATE_RESOURCE}` as const;

export type CompanyCreateBody =
  paths[typeof COMPANY_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type CompanyCreateInput = Omit<CompanyCreateBody, "logo"> & {
  logo?: File;
};
export type CompanyCreateResponse =
  paths[typeof COMPANY_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useCompanyCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CompanyCreateResponse, Error, CompanyCreateInput>({
    mutationFn: async (body: CompanyCreateInput) => {
      const response = await alphartisApiAxios.post<CompanyCreateResponse>(
        COMPANY_CREATE_API_PATH,
        await encodeLogoRequest(body),
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [COMPANY_CREATE_RESOURCE],
      });
    },
  });
};
